import axios from 'axios'
import {vm} from '@/main'

var baseUrl = process.env.VUE_APP_BASE_URL

const cargos = {
    state: {
        cargos: null,
        showAddCargoForm: false,
        cargoInputData: null,
        showCargoModal : false
    },

    mutations: {
        setCargos(state, cargos){
            state.cargos = cargos
        },
        showAddCargoForm(state){
            state.showAddCargoForm = true
        },
        hideAddCargoForm(state){
            state.showAddCargoForm = false
        },
        setInputData(state, payload){
            state.cargoInputData = payload
        },
        showCargoModal(state){
            state.showCargoModal = true
        },
        hideCargoModal(state){
            state.showCargoModal = false
        }
    },

    actions: {
        getCargos({ commit, rootState, dispatch, state }, page){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/search_cargos?page='+page +'&q='+rootState.search)
                    .then(response => {
                        commit('setCargos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getCargoInputData({ commit, rootState, dispatch }){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/cargos/create')
                    .then(response => {
                        commit('setInputData', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        createNewCargo({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/cargos', {
                    name: formData.name,
                    un_nr: formData.unNr,
                    cleaning_program_id: formData.cleaningProgram,
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getCargos')
                        commit('hideAddCargoForm')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },

        createNewCargoFromModal({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/cargos', {
                    name: formData.name,
                    un_nr: formData.unNr,
                    cleaning_program_id: formData.cleaningProgram,
                })
                    .then(response => {
                        const token = response.data.access_token
                        dispatch('getCleaningInputData')
                        commit('hideCargoModal')
                        vm.$Progress.finish()
                        dispatch('setSnackbar', {
                            color: 'green',
                            text: 'Krava pievienota'
                        })
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },
        deleteCargo({commit, rootState, dispatch, state}, cargoId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.delete(baseUrl +'/api/cargos/'+cargoId)
                    .then(response => {
                        dispatch('getCargos')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        showAddCargoForm({ commit }){
            commit('showAddCargoForm')
        },
        hideAddCargoForm({ commit }){
            commit('hideAddCargoForm')
        },
        showCargoModal({ commit }){
            commit('showCargoModal')
        },
        hideCargoModal({ commit }){
            commit('hideCargoModal')
        },
    },
    getters: {
        cargos(state){
            return state.cargos
        },
        showAddCargoForm(state){
            return state.showAddCargoForm
        },
        cargoInputData(state){
            return state.cargoInputData
        },
        showCargoModal(state){
            return state.showCargoModal
        }
    }
}

export default cargos